// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { action, makeObservable, observable } from 'mobx';

export class UiStore extends Store {
  public cookieConsentBannerEnabled;
  public navLoaded: boolean;
  public pageName: string;
  public pzClientId: string;
  public pzRedirectUri: string;
  public osanoURL;
  public osanoUpdateLocale;
  public osanoLoaded: boolean;
  public supportedLocales;
  public flexDocumentPrefix: string;
  public documentName: string;

  constructor(config, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      cookieConsentBannerEnabled: observable,
      supportedLocales: observable,
      navLoaded: observable,
      pageName: observable,
      setNavLoaded: action,
      osanoURL: observable,
      pzClientId: observable,
      pzRedirectUri: observable,
      osanoUpdateLocale: observable,
      osanoLoaded: observable,
      setOsanoLoaded: action,
      setPageName: action,
      flexDocumentPrefix: observable,
      documentName: observable,
      setDocumentName: action,
    });

    this.supportedLocales = config.app?.supportedLocales;

    this.navLoaded = false;

    this.cookieConsentBannerEnabled = config.app?.osano.enabled;
    this.osanoURL = config.app?.osano.url;
    this.osanoUpdateLocale = config.app?.osano.updateLocale;

    this.flexDocumentPrefix = config.app?.flexDocumentPrefix;

    this.pzClientId = config.secrets?.pzClientID;
    this.pzRedirectUri = config.partnerize?.redirect_uri;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setOsanoLoaded(loaded: boolean) {
    this.osanoLoaded = loaded;
  }

  public setNavLoaded(visible: boolean) {
    this.navLoaded = visible;
  }

  public setPageName(name: string) {
    this.pageName = name;
  }

  public setDocumentName(documentName: string) {
    this.documentName = documentName;
  }
}
